<template>
  <div class="loading-vecino-overlay">
    <div class="loading-box">
      <div class="loading-spinner"></div>
      <p v-if="message">{{ message }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  message: {
    type: String,
    default: "Cargando...",
  },
});
</script>

<style scoped>
.loading-vecino-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;

  background: transparent;
  backdrop-filter: blur(8px);

  display: flex;
  align-items: center;
  justify-content: center;
}

/* Caja del spinner */
.loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #444;
  font-weight: 500;
}

/* Spinner */
.loading-spinner {
  border: 4px solid #00c3a8;
  border-left-color: var(--verdePrimario);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-box p {
  color: var(--text-primary);
}

/* -------------------------------------------------------------------------- */
/* RESPONSIVE MOBILE STYLES                         */
/* -------------------------------------------------------------------------- */

/* Define el punto de corte (breakpoint) para móvil, por ejemplo, 768px */
@media (max-width: 768px) {
  /* Contenedor principal del modal */
  .modal-content {
    /* Fija la altura total del modal, aprovechando el espacio desde abajo */
    height: 40vh;
    width: 80vw;

    /* Asegura que el contenido interno pueda scrollear */
    overflow: hidden; /* Esto ya estaba, pero lo confirmamos */
  }
}
</style>
